import { gql } from '__generated__';

export default gql(`
  mutation ClaimRegistration($input: EditRegistrationInput!) {
    editRegistration(input: $input) {
      id
      participant {
        id
      }
    }
  }
`);
